import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import dayjs from "dayjs";
import DatePicker from "../../../components/common/DatePicker";
import Subtitle from "../../../components/common/Subtitle";
import QuarterButton from "./QuarterButton";

/**
 * DateSelectionSection component for handling date selection and date-related controls
 * @param {Object} props - Component props
 * @param {Object} props.selectedTaskData - Selected task data containing dates
 * @param {Function} props.setSelectedTaskData - Function to update task data
 * @returns {JSX.Element}
 */
const DateSelectionSection = ({ selectedTaskData, setSelectedTaskData }) => {
  const handleYearAdjustment = (adjustment) => {
    setSelectedTaskData((prev) => ({
      ...prev,
      startDate: dayjs(selectedTaskData.startDate).add(adjustment, "year"),
      endDate: dayjs(selectedTaskData.endDate).add(adjustment, "year"),
    }));
  };

  const handleDateChange = (field) => (val) => setSelectedTaskData((prev) => ({ ...prev, [field]: val }));

  return (
    <Grid size={{ xs: 12, sm: 6 }} sx={{ px: 7 }}>
      <Grid container direction="row" alignItems="center" justifyContent="center" spacing={3}>
        {/* Date Pickers */}
        <Grid size={{ xs: 12, sm: 6 }} sx={{ textAlign: "center" }}>
          <Subtitle text="Start Date" sx={{ fontSize: "1.3rem" }} />
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <DatePicker currentVal={selectedTaskData.startDate} handleVal={handleDateChange("startDate")} />
          </Box>
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }} sx={{ textAlign: "center" }}>
          <Subtitle text="End Date" sx={{ fontSize: "1.3rem" }} />
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <DatePicker currentVal={selectedTaskData.endDate} handleVal={handleDateChange("endDate")} />
          </Box>
        </Grid>
      </Grid>

      {/* Quarter Selection */}
      <Grid container spacing={5} justifyContent="center" mt={4}>
        <QuarterButton
          quarter="Q1"
          startMonth={0}
          endMonth={2}
          label="Jan 1 ➔ Mar 31"
          setSelectedTaskData={setSelectedTaskData}
        />
        <QuarterButton
          quarter="Q2"
          startMonth={3}
          endMonth={5}
          label="Apr 1 ➔ Jun 30"
          setSelectedTaskData={setSelectedTaskData}
        />
        <QuarterButton
          quarter="Q3"
          startMonth={6}
          endMonth={8}
          label="Jul 1 ➔ Sep 30"
          setSelectedTaskData={setSelectedTaskData}
        />
        <QuarterButton
          quarter="Q4"
          startMonth={9}
          endMonth={11}
          label="Oct 1 ➔ Dec 31"
          setSelectedTaskData={setSelectedTaskData}
        />
      </Grid>

      {/* Year Adjustment */}
      <Grid container spacing={5} justifyContent="center" mt={6}>
        <Grid>
          <Button variant="outlined" color="inherit" size="large" onClick={() => handleYearAdjustment(-1)}>
            Year -
          </Button>
        </Grid>
        <Grid>
          <Button variant="outlined" color="inherit" size="large" onClick={() => handleYearAdjustment(1)}>
            Year +
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DateSelectionSection;
